import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from '@capgo/capacitor-native-biometric';

const server = 'app.paytron.com.au';

export class Biometrics {
    private hasVerifiedIdentity: boolean;

    private isMobile: boolean;

    constructor() {
        this.hasVerifiedIdentity = false;
        const platform = Capacitor.getPlatform();
        this.isMobile = platform === 'ios' || platform === 'android';
    }

    public async validateIdentity() {
        if (!this.isMobile) {
            return true;
        }
        if (this.hasVerifiedIdentity) {
            return true;
        }
        const isAvailable = await NativeBiometric.isAvailable();
        if (!isAvailable.isAvailable) {
            return true;
        }
        const verified = await NativeBiometric.verifyIdentity()
            .then(() => true)
            .catch(() => false);

        this.hasVerifiedIdentity = verified;
        return verified;
    }

    public invalidateIdentity() {
        this.hasVerifiedIdentity = false;
    }

    public async getCredentials() {
        if (!this.isMobile) {
            return;
        }
        if (this.hasVerifiedIdentity) {
            return NativeBiometric.getCredentials({ server })
                .then((response) => response)
                .catch((error) => {
                    console.log(error);
                    return null;
                });
        }
        const isVerified = await this.validateIdentity();
        if (isVerified) {
            return NativeBiometric.getCredentials({ server })
                .then((response) => response)
                .catch((error) => {
                    console.log(error);
                    return null;
                });
        }
    }

    public async registerCredentials({ username, password }: { username?: string; password?: string }) {
        if (!this.isMobile) {
            return;
        }
        const currentBiometrics = await NativeBiometric.getCredentials({ server })
            .then((response) => response)
            .catch((error) => {
                console.log(error);
                return null;
            });
        if (currentBiometrics?.username === username && currentBiometrics?.password === password) {
            return;
        }
        if (!this.hasVerifiedIdentity) {
            const isVerified = await this.validateIdentity();
            if (!isVerified) {
                return;
            }
        }
        await NativeBiometric.deleteCredentials({ server }).catch((error) => console.log(error));
        await NativeBiometric.setCredentials({
            username: username ?? '',
            password: password ?? '',
            server,
        }).catch((error) => console.log(error));
    }
}
